export default "__VITE_ASSET__CmQA0cnG__"